import { __rest } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';
import { getStyle } from './utils.es.js';
import { I as Image } from './Image-b56e679c.js';
import styled from '@emotion/styled';
import './InputNumber-7d93e963.js';
import './components/shared/Link.es.js';
import 'rc-select';
import '@teko-builder/icons';
import './FormItem-098fa619.js';
import './DateTimePickerMobile-749dc497.js';
import './RadioGroup-4b4abf08.js';
import './Col-475038db.js';
import { D as DSSlider } from './Slider-93041044.js';
import './Container-ca9f82d8.js';
import './Divider-600cb92e.js';
import './Ripple-abf0f8a0.js';
import './Image-efa43cf5.js';
import './ModalHeader-a3d30e4f.js';
import './Spin-a6892495.js';

const arrowWidth = 12;
const defaultLayoutCss = (layout) => {
    switch (layout) {
        case 'imageAbove':
            return `display: grid;
            grid-template-rows: auto auto auto;
            grid-template-columns: 1fr;
            .testimonial {
              &__content {
                grid-row: 2/3;
              }
              &__image {
                grid-row: 1/2;
              }
              &__footer {
                grid-row: 3/4;
              }
            }`;
        case 'imageStacked':
            return `display: grid;
            grid-template-rows: auto auto auto;
            grid-template-columns: 1fr;
            .testimonial {
              &__content {
                grid-row: 1/2;
              }
              &__image {
                grid-row: 2/3;
              }
              &__footer {
                grid-row: 3/4;
              }
            }`;
        case 'imageInline':
            return `display: flex; 
            flex-wrap: wrap;
            align-items: center;`;
        case 'imageRight':
            return `display: grid;
            grid-template-rows: auto 1fr;
            grid-template-columns: 1fr auto;
            .testimonial {
              &__content {
                grid-row: 1/2; 
                grid-column: 1/2;
              }
              &__image {
                grid-row: 1/3; 
                grid-column: 2/3;
              }
              &__footer {
                grid-row: 2/3; 
                grid-column: 1/2;
              }
            }`;
        case 'imageLeft':
            return `display: grid;
            grid-template-rows: auto 1fr;
            grid-template-columns: auto 1fr;
            .testimonial {
              &__content {
                grid-row: 1/2;
                grid-column: 2/3;
              }
              &__image {
                grid-row: 1/3; 
                grid-column: 1/2;
              }
              &__footer {
                grid-row: 2/3; 
                grid-column: 2/3;
              }
            }`;
        default:
            return '';
    }
};
const bubbleLayoutCss = (layout) => {
    switch (layout) {
        case 'imageAbove':
            return `display: flex; 
            align-items: center;
            flex-wrap: wrap;
            .testimonial {
              &__image {
                order: 1;
              }
              &__footer {
                order: 2;
              }
              &__content {
                order: 3;
              }
            }`;
        case 'imageStacked':
            return `display: grid;
            grid-template-rows: auto auto auto;
            grid-template-columns: 1fr;
            .testimonial {
              &__content {
                grid-row: 1/2;
              }
              &__image {
                grid-row: 2/3;
              }
              &__footer {
                grid-row: 3/4;
              }
            }`;
        case 'imageInline':
            return `display: flex; 
            flex-wrap: wrap;
            align-items: center;`;
        case 'imageRight':
            return `display: grid;
            grid-template-rows: auto 1fr;
            grid-template-columns: 1fr auto;
            .testimonial {
              &__content {
                grid-row: 1/3; 
                grid-column: 1/2;
              }
              &__image {
                grid-row: 1/2; 
                grid-column: 2/3;
              }
              &__footer {
                grid-row: 2/3; 
                grid-column: 2/3;
              }
            }`;
        case 'imageLeft':
            return `display: grid;
            grid-template-rows: auto 1fr;
            grid-template-columns: auto 1fr;
            .testimonial {
              &__content {
                grid-row: 1/3;
                grid-column: 2/3;
              }
              &__image {
                grid-row: 1/2; 
                grid-column: 1/2;
              }
              &__footer {
                grid-row: 2/3; 
                grid-column: 1/2;
              }
            }`;
        default:
            return '';
    }
};
const getArrowClassName = (layout, alignment) => {
    return `arrow-${layout
        .split(/(?=[A-Z])/)
        .join('-')
        .toLowerCase()}-${alignment}`;
};
const arrowPositionAttribute = (className) => {
    if (className.includes('inline') || className.includes('stacked'))
        return 'bottom';
    if (className.includes('image-left'))
        return 'left';
    if (className.includes('image-right'))
        return 'right';
    if (className.includes('above'))
        return 'top';
};
const gapCss = (layout) => {
    switch (layout) {
        case 'imageAbove':
            return `.testimonial__content { margin-top: ${arrowWidth + 8}px; }`;
        case 'imageStacked':
        case 'imageInline':
            return `.testimonial__content { margin-bottom: ${arrowWidth + 8}px; }`;
        case 'imageRight':
        case 'imageLeft':
            return `column-gap: ${arrowWidth + 8}px;`;
        default:
            return '';
    }
};
const styledItemCss = (skin, layout) => {
    switch (skin) {
        case 'bubble':
            return `${bubbleLayoutCss(layout)} 
              ${gapCss(layout)}`;
        case 'default':
            return defaultLayoutCss(layout);
        default:
            return '';
    }
};
const contentWrapperCss = (skin, commonStyle) => {
    switch (skin) {
        case 'bubble':
            return getStyle(commonStyle);
        case 'default':
            return '.arrow{ display: none; }';
        default:
            return '';
    }
};
const StyledItem = styled.div(({ width, layout, alignment, skin }) => `
      width: ${width || 100}%;
      justify-content: ${alignment === 'left'
    ? 'flex-start'
    : alignment === 'right'
        ? 'flex-end'
        : 'center'};
      .image{
        padding: 12px;
      }
      ${styledItemCss(skin, layout)}
    `);
const Content = styled.div(({ commonStyle }) => `
      ${getStyle(commonStyle)}
    `);
const Name = styled.div(({ commonStyle }) => `
      ${getStyle(commonStyle)}
    `);
const Title = styled.div(({ commonStyle }) => `
      ${getStyle(commonStyle)}
    `);
const ContentWrapper = styled.div(({ skin, commonStyle }) => `
  width: 100%;
  position: relative;
  ${contentWrapperCss(skin, commonStyle)}`);
const Arrow = styled.div(({ imgWidth, className }) => `
    position: absolute;
    width: ${arrowWidth}px;
    height: ${arrowWidth}px;
    background: inherit;
    z-index: -1;
    transform: rotate(45deg);
    ${arrowPositionAttribute(className)}: -${arrowWidth / 2}px;
    &.arrow-image-inline-left, 
    &.arrow-image-stacked-left, 
    &.arrow-image-above-left {
      left: ${imgWidth / 2 - arrowWidth / 2}px;
    }
    &.arrow-image-inline-right,
    &.arrow-image-stacked-right, 
    &.arrow-image-above-right {
      right: ${imgWidth / 2 - arrowWidth / 2}px;
    }
    &.arrow-image-inline-center,
    &.arrow-image-stacked-center, 
    &.arrow-image-above-center {
      right: calc(50% - ${arrowWidth / 2}px);
    }
    ${className.includes('image-left') || className.includes('image-right')
    ? `top: ${imgWidth / 2 - arrowWidth / 2}px;`
    : ''}
  `);

const TestimonialItem = ({ image, imageStyle, content, contentStyle, title, titleStyle, name, nameStyle, width, alignment, layout, skin, bubbleStyle, }) => {
    const arrowAlign = layout === 'imageInline' || layout === 'imageAbove'
        ? alignment
        : imageStyle === null || imageStyle === void 0 ? void 0 : imageStyle.alignment;
    return (jsxs(StyledItem, Object.assign({ width: width, layout: layout, alignment: alignment, skin: skin }, { children: [jsxs(ContentWrapper, Object.assign({ skin: skin, className: "testimonial__content", commonStyle: bubbleStyle }, { children: [jsx(Content, Object.assign({ commonStyle: contentStyle }, { children: content })), jsx(Arrow, { className: `arrow ${getArrowClassName(layout, arrowAlign || 'center')}`, imgWidth: imageStyle.width })] })), jsx("div", Object.assign({ className: "testimonial__image" }, { children: jsx(Image, Object.assign({}, image, { commonStyle: Object.assign(Object.assign({}, imageStyle), { height: imageStyle.width, objectFit: 'cover' }), alignment: imageStyle.alignment })) })), jsxs("div", Object.assign({ className: "testimonial__footer" }, { children: [jsx(Name, Object.assign({ commonStyle: nameStyle }, { children: name })), jsx(Title, Object.assign({ commonStyle: titleStyle }, { children: title }))] }))] })));
};

const TestimonialCarousel = (_a) => {
    var { items, commonStyle, contentStyle, nameStyle, titleStyle, imageStyle, bubbleStyle, width, alignment = 'center', layout, skin } = _a, sliderConfig = __rest(_a, ["items", "commonStyle", "contentStyle", "nameStyle", "titleStyle", "imageStyle", "bubbleStyle", "width", "alignment", "layout", "skin"]);
    return (jsx(StyledTestimonialCarousel, Object.assign({ commonStyle: commonStyle }, { children: jsx(DSSlider, Object.assign({}, sliderConfig, { children: items.map((testimonial, index) => (jsx(ItemWrapper, Object.assign({ alignment: alignment }, { children: jsx(TestimonialItem, Object.assign({}, testimonial, { skin: skin, contentStyle: contentStyle, titleStyle: titleStyle, nameStyle: nameStyle, imageStyle: imageStyle, bubbleStyle: bubbleStyle, width: width, alignment: alignment, layout: layout })) }), index))) })) })));
};
const StyledTestimonialCarousel = styled.div(({ commonStyle }) => `
    ${getStyle(commonStyle)}
  `);
const ItemWrapper = styled.div(({ alignment }) => `
    display: flex;
    justify-content: ${alignment === 'left'
    ? 'flex-start'
    : alignment === 'right'
        ? 'flex-end'
        : 'center'};
`);
TestimonialCarousel.displayName = 'TestimonialCarousel';

export { TestimonialCarousel as T, TestimonialItem as a };
